<template>
  <DsPageLayout
    prevent-loading
    prevent-transition
    style="margin-top: 0"
    :theme="theme"
    :custom-theme="customTheme"
  >
    <template #header>
      <div class="ds-container ds-padding-y-24">
        <div class="ds-grid">
          <div class="ds-grid__col ds-grid__col--12 ds-display-flex ds-justify-content-space-between">
            <DsHeaderLogoLink
              theme="grey"
              :url="homePath"
              nuxt
              aria-label="Adyen"
            />
            <div
              id="portal-header"
              ref="headerPortal"
              @change="handleHeaderPortalUpdate($event, headerPortal)"
            />
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div
        :style="{ paddingTop: `${headerPortalHeight}px` }"
        class="ds-width-full"
      >
        <slot />
      </div>
    </template>
    <template #footer>
      <PageFooter
        v-if="footerNavigationData"
        :footer-data="footerNavigationData"
      />
    </template>
    <template #overlay>
      <div id="portal-overlay" />
    </template>
  </DsPageLayout>
</template>

<script setup lang="ts">
import { DsHeaderLogoLink, DsPageLayout } from 'awds'
import PageFooter from '#layers/core/components/layout/PageFooter.vue'

const { locale } = useI18n()
const { defaultLocale } = useLocales()
const { handleHeaderPortalUpdate, headerPortalHeight } = useLayout()
const { localeGlobalContentData } = useGlobalData()
const { value: errorValue } = useError()

const headerPortal = ref()
const homePath = computed(() => {
  return useRuntimeConfig().public.mainSiteUrl + (locale.value === defaultLocale ? '' : `/${locale.value}`)
})
const theme = computed(() => (errorValue ? 'light' : 'custom'))
const customTheme = computed(() => '#004117')
const footerNavigationData = computed(() => localeGlobalContentData.value?.globalFooterData?.['main'])
</script>
